import { Api } from '@/interface/api';

/**
 * 获取数据列表
 * @param accountId
 */
const getDatasets: Api = {
    url: '/api/project/proxy/api/dwq/datasets',
    method: 'get',
};

/**
 * 获取数据详情
 * @param accountId
 */
const getDatasetsDetails: Api = {
    url: '/api/project/proxy/api/datasets',
    method: 'get',
};

export { getDatasets, getDatasetsDetails };
